import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-error\"><path d=\"M512 896A384 384 0 1 0 512 128a384 384 0 0 0 0 768z m0 64A448 448 0 1 1 512 64a448 448 0 0 1 0 896z m0-493.2l137.3-137.4a32 32 0 0 1 45.3 45.3L557.2 512l137.4 137.3a32 32 0 0 1-45.3 45.3L512 557.2l-137.3 137.4a32 32 0 0 1-45.3-45.3L466.8 512 329.3 374.7a32 32 0 1 1 45.3-45.3L512 466.8z\" p-id=\"567\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol